import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CheckCircle2 } from 'lucide-react';
import { useTaskStore } from '../store/taskStore';
import { TaskCard } from '../components/tasks/TaskCard';

/**
 * Coach change reports — the Needs Attention banner's landing screen when more
 * than one heads-up is open. Just the viewer's pending reports, full card face
 * (evidence + Review/Dismiss), nothing else. Mobile-first by design.
 */
export const CoachChangeReports = () => {
  const navigate = useNavigate();
  const { tasks, isLoading, fetchTasks } = useTaskStore();

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  const reports = tasks.filter(
    (t) => t.meta?.kind === 'COACH_MOVE_NOTIFY' && t.status === 'PENDING',
  );

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-1 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 mb-4"
      >
        <ArrowLeft className="h-4 w-4" />
        <span className="text-sm">Back</span>
      </button>

      <h1 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-1">
        Coach change reports
      </h1>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
        Reps flagged these coaches as no longer at their school. Review to make
        the change, or dismiss if they're still there.
      </p>

      {isLoading && reports.length === 0 ? (
        <div className="card p-8 text-center text-sm text-gray-500 dark:text-gray-400">Loading…</div>
      ) : reports.length === 0 ? (
        <div className="card p-8 text-center">
          <CheckCircle2 className="h-10 w-10 mx-auto mb-3 text-blast-500 dark:text-blast-400" />
          <p className="text-base font-semibold text-gray-900 dark:text-gray-100">All caught up</p>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">No coach change reports waiting on you.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {reports.map((t) => (
            <TaskCard key={t.id} task={t} />
          ))}
        </div>
      )}
    </div>
  );
};
